/**
 * Coming soon badge on Drone Processing.
 *
 * Production: leave `true` as it is. The menu shows the badge and the page stays closed.
 * Local testing: comment out `true` and uncomment `false`.
 */
export const DRONE_PROCESSING_COMING_SOON =
  false
  // false
  ;
